interface SubstanciaMedicamentoModel {
  principioAtivo: string
  concentracao: string
}
export const formatNomePrincipioAtivo = ({ principioAtivo, concentracao }: SubstanciaMedicamentoModel) => {
  return !concentracao ? principioAtivo : principioAtivo + ' - ' + concentracao
}
